
import { AppEnvironment, overrideWithUserEnvironment } from './environment-util';

declare const injectedUserEnv: Record<string, string | number | boolean> | undefined;

export const environment: AppEnvironment = overrideWithUserEnvironment({
    supportedLanguages: {
        'en-ca': {
            underMaintenanceHeadsupStatement: "Please note that Survey Instruments will be soon unavailable.",
            privacyPolicy: "https://healthstandards.org/privacy-notice-hso-survey-instruments-platform/",
            termsOfUse: "https://healthstandards.org/terms-of-use-survey-instruments-platform/",
        },
        'fr-ca': {
            underMaintenanceHeadsupStatement: "Veuillez noter que les Sondages seront bientôt indisponibles.",
            privacyPolicy: "https://healthstandards.org/fr/avis-de-confidentialite-plateforme-de-sondage-hso/",
            termsOfUse: "https://healthstandards.org/fr/conditions-dutilisation-plateforme-doutils-de-sondages/",
        },
        'it-it': {
            underMaintenanceHeadsupStatement: "Si prega di notare che gli Strumenti di Sondaggio saranno presto non disponibili.",
            privacyPolicy: "https://healthstandards.org/it/informativa-sulla-privacy-piattaforma-degli-strumenti-di-indagine-di-hso/",
            termsOfUse: "https://healthstandards.org/it/termini-e-condizioni-di-utilizzo-piattaforma-degli-strumenti-di-indagine/",
        },
        'es-es': {
            underMaintenanceHeadsupStatement: "Por favor, tenga en cuenta que los Instrumentos de Encuesta pronto estarán no disponibles.",
            privacyPolicy: "https://healthstandards.org/es/aviso-de-privacidad-plataforma-de-instrumentos-de-encuesta-hso/",
            termsOfUse: "https://healthstandards.org/es/condiciones-de-uso-plataforma-de-instrumentos-de-encuesta-2/",
        },
        'fr-be': {
            underMaintenanceHeadsupStatement: "Veuillez noter que les Sondages seront bientôt indisponibles.",
            privacyPolicy: "https://healthstandards.org/fb/avis-de-confidentialite-plateforme-dinstruments-de-sondage-hso/",
            termsOfUse: "https://healthstandards.org/fb/conditions-dutilisation-plateforme-dinstruments-de-sondage/",
        },
        'pt-br': {
            underMaintenanceHeadsupStatement: "Por favor, note que os Instrumentos de Pesquisa estarão indisponíveis em breve.",
            privacyPolicy: "https://healthstandards.org/pt-pt/aviso-de-privacidade-plataforma-de-instrumentos-de-pesquisa-hso/",
            termsOfUse: "https://healthstandards.org/pt-pt/termos-de-uso-plataforma-de-instrumentos-de-pesquisa/",
        },
    },
    baseHref: '',
    buildTimestamp: `${new Date().getTime()}`,
    production: false,
    api: {
        baseUrl: "https://instruments-dev-api.spark.healthstandards.org",
        xApiKey: "ddPHh8zT4HjBe?8$C85S!kEYp44J7XL6PH5#qHintSoiIiwicHJvZ3JhbUNvZGUiOiIiLCJyb2xlcyI6WyJST0xFX0FTU0VTU09SIl19XSwiYXNzZXNzb3IiOiJ0cnVlIiwiaWF0IjoxNzI5MTc5MTgyLCJleHAiOjE4MTU1NzkxODJ9.acDLTDDRl_E9PDbCFo_E0XH07NKmVSFyggnj7VNVyQ_OCcda12MT-IG8Y3tktgdoBYmKZ7evPmluESO_LCJNohb9GaXhkQSeAUcpRiIGzCX8CX6bx-scjXe7CLfm_XH9effSSdjxFVUgDvUaYcOUOjSuaRLTWxBhoRj4MkjJndWnT9YJOxbAVS-Ctp9q6EkqCXJyQwGcWfgaqBRanGlReEmUcV-q7SAqXol8W8_DCKLl2h8vk-MjCVBoanpUj4Ecr7YTIOULqWVq01ocU6gKXd6M5gj9qtuVOkWyxU9Sbj7sS3JF2Ifm6Fdz3jtk-Plv62Hjy4ZqaZPWN9yxtARxx",
        services: {
            authentication: "/v1/authentication",
            glossary: '/v1/glossary',
        },
    },
    storageKeys: {
        auth: {
            accessToken: 'Q10KX7A1tc',
            refreshToken: 'r38KciwFzK',
            refreshTokenExpiry: 'zSLVnz9zfO',
            currentOrganization: 'fTOQG2sZ7Z',
            authorizedOrganizations: 'LohEUG6nlY',
        },
        rememberMe: 'uPcg2c1X7L',
    },
    underMaintenance: {
        activated: undefined,
        activationDate: undefined,
        headsupEnabled: false,
    },
}, injectedUserEnv)